// Mock data for Kaftan Queens — R&F-inspired redesign
// Copy preserved from kaftanqueens.co.uk; visuals supplemented with editorial imagery

export const SHOP_BASE = "https://kaftanqueens.co.uk";
export const SHOP_COLLECTION_URL = `${SHOP_BASE}/collections/all`;
export const SHOP_CART_URL = `${SHOP_BASE}/cart`;

// Map of product ID → shopify handle (only when different from the local id)
const SHOP_HANDLES = {
  "goa-mens-shirt": "kerala-mens-korta-shirt",
};
export function shopUrlFor(productId) {
  const handle = SHOP_HANDLES[productId] || productId;
  return `${SHOP_BASE}/products/${handle}`;
}

export const SITE = {
  name: "Kaftan Queens",
  shortName: "K&Q",
  tagline:
    "A boutique slow-fashion house presenting handmade kaftans, scarves and shirts by artisans of Northern India — crafted with natural, sustainable materials.",
  email: "hello@kaftanqueens.co.uk",
  instagram: "https://www.instagram.com/kaftan.queens/",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "Our Story", to: "/about" },
];

export const HERO_SLIDES = [
  {
    eyebrow: "— Hand-printed in India",
    title: "Kaftan Queens",
    sub: "Rare, handmade pieces — made to be lived in.",
    image: "/hero/hero1-desktop.jpg",
    imageMobile: "/hero/hero1-mobile.jpg",
    pos: "center bottom",
  },
  {
    eyebrow: "— Scarves from Kashmir",
    title: "Colour, woven in.",
    sub: "Sun-drenched mornings to layered winter escapes.",
    image: "/hero/hero2-desktop.jpg",
    imageMobile: "/hero/hero2-mobile.jpg",
    pos: "center 40%",
  },
];

const CDN = "https://cdn.shopify.com/s/files/1/0928/7027/9498/files/";

// Helper: flatten variants into a single images array for grid cards.
function flat(variants) {
  return variants.flatMap((v) => v.images);
}

// Variants below mirror the official colour list on Kaftan Queens' Shop store
// (each colour maps to its dedicated swatch image where available).

const palmKaftanVariants = [
  { colour: "Pink", images: [`${CDN}Palmpinkandgreenkaftan.heic?v=1761750123&width=1200`] },
  { colour: "Green & Fuchsia", images: [`${CDN}Palmbeigekaftan2.heic?v=1761750123&width=1200`] },
  { colour: "Blue & Red", images: [`${CDN}Palmblueandredkaftan.heic?v=1761750122&width=1200`] },
  { colour: "Orange", images: [`${CDN}Palm_peach_kaftan.heic?v=1761750299&width=1200`] },
];

const palmDressVariants = [
  { colour: "Blue & Pink", images: [`${CDN}Palmblueandpinkdress.heic?v=1761750246&width=1200`] },
  { colour: "Blue Pattern", images: [`${CDN}Palmbluedress3.heic?v=1762429162&width=1200`] },
  { colour: "Fuchsia", images: [`${CDN}Palmfusiadress.heic?v=1762429162&width=1200`, `${CDN}Palmpinkdress2.heic?v=1761750246&width=1200`] },
  { colour: "Orange", images: [`${CDN}Palmorangedress3.heic?v=1761750245&width=1200`, `${CDN}Palmorangedress2.heic?v=1761750246&width=1200`] },
  { colour: "Yellow", images: [`${CDN}Palmyellowdress3.heic?v=1761750245&width=1200`] },
];

const kimonoVariants = [
  { colour: "Kimono Pink", images: [`${CDN}Pinkkimono2.heic?v=1761750652&width=1200`] },
  { colour: "Kimono Yellow", images: [`${CDN}Yellowkimono.heic?v=1761750652&width=1200`] },
  { colour: "Kimono Fuchsia", images: [`${CDN}Fushiapinkkimono3.heic?v=1761750652&width=1200`] },
];

const hampiVariants = [
  { colour: "Navy Blue", images: [`${CDN}Hampi_Navy_Blue_Shirt_2.jpg?v=1763043582&width=1200`, `${CDN}HampiNavyBlueShirt.jpg?v=1763043468&width=1200`, `${CDN}HampiNavyBlueShirt2.jpg?v=1763043467&width=1200`] },
  { colour: "Pink", images: [`${CDN}Hampi_Pink_Shirt.jpg?v=1763043582&width=1200`, `${CDN}HampiPinkShirt.jpg?v=1763043466&width=1200`, `${CDN}HampiPinkShirt2.jpg?v=1763043467&width=1200`, `${CDN}HampiPinkShirt3.jpg?v=1763043466&width=1200`] },
  { colour: "Denim Blue", images: [`${CDN}Hampi_Denim_Blue_Shirt_3.jpg?v=1763043582&width=1200`, `${CDN}HampiDenimBlueShirt3.jpg?v=1763043582&width=1200`, `${CDN}HampiDenimBlueShirt2.jpg?v=1763043582&width=1200`, `${CDN}HampiDenimBlueShirt.jpg?v=1763043466&width=1200`] },
  { colour: "White", images: [`${CDN}Hampi_White_Shirt_2.jpg?v=1763043582&width=1200`, `${CDN}HampiWhiteShirt.jpg?v=1763043467&width=1200`, `${CDN}HampiWhiteShirt2.jpg?v=1763043467&width=1200`, `${CDN}HampiWhiteShirt3.jpg?v=1763043466&width=1200`] },
];

const goaVariants = [
  { colour: "Pink Flower", images: [`${CDN}KeralaKortapinkflowerXL_6f8d6913-8162-4644-a49a-fefaa9bd45d0.jpg?v=1761750376&width=1200`, `${CDN}KeralaKortapinkflowerXL2.jpg?v=1761750376&width=1200`] },
  { colour: "Blue Pattern", images: [`${CDN}KeralaKortaBluepatternXL_c96fa810-81a5-488c-a292-0575104080e6.jpg?v=1761750376&width=1200`, `${CDN}KeralaKortaBluepatternXL2_8cbf2f14-bd30-4b42-80b4-8c5b73a26a53.jpg?v=1761750377&width=1200`] },
  { colour: "Blue Flower", images: [`${CDN}KeralaKortablueflowerXL_144671d0-c2e5-45ed-ba60-c3551876f7f3.jpg?v=1761750376&width=1200`, `${CDN}KeralaKortablueflowerXL2_acb651af-f8a8-4eb8-ad74-b2be34f6d9ef.jpg?v=1761750377&width=1200`] },
  { colour: "White Flower", images: [`${CDN}KeralaKortawhiteflowerondenimXL.jpg?v=1761750377&width=1200`, `${CDN}KeralaKortawhiteflowerondenimXL2.jpg?v=1761750376&width=1200`, `${CDN}KeralaKortawhiteflowerondenimXL3.jpg?v=1761750377&width=1200`] },
  { colour: "Lilac Flower", images: [`${CDN}KeralaKortapurplefloweronwhiteXL.jpg?v=1761750377&width=1200`, `${CDN}KeralaKortapurplefloweronwhiteXL2.jpg?v=1761750376&width=1200`] },
];

const keralaVariants = [
  { colour: "Blue Flower", images: [`${CDN}Keralablueflowermen_scottonshirtL.heic?v=1761750458&width=1200`, `${CDN}Keralablueflowermen_scottonshirtL2.heic?v=1761750459&width=1200`] },
  { colour: "Fuchsia", images: [`${CDN}Keralafushiaflowermen_scottonshirtL2.heic?v=1761750459&width=1200`] },
  { colour: "Green & Orange", images: [`${CDN}Keralagreenblockmen_scottonshirtL_45730605-055a-4193-ada7-0de1cf062fef.heic?v=1761750459&width=1200`] },
  { colour: "Blue Pattern", images: [`${CDN}Keralabeigewithturquoiseflowersmen_scottonshirtL.heic?v=1761750459&width=1200`] },
  { colour: "Navy Blue Block Print", images: [`${CDN}KeralanavyblockonwhitemenscottonshirtL3.heic?v=1761750459&width=1200`, `${CDN}KeralanavyblockonwhitemenscottonshirtL.heic?v=1761750459&width=1200`] },
  { colour: "Pink Frangipani", images: [`${CDN}KeralapinkfrangipanimenscottonshirtL.heic?v=1761750458&width=1200`, `${CDN}KeralapinkfrangipanimenscottonshirtL2.heic?v=1761750459&width=1200`] },
  { colour: "Pale Blue Block Print", images: [`${CDN}Keralapaleblueblockmen_scottonshirtL2.heic?v=1761750458&width=1200`] },
];

const bagsVariants = [
  { colour: "Black & Cream", images: [`${CDN}IndianBags1_b1392fe3-5266-4abb-bdc3-69b9910dc088.jpg?v=1761682331&width=1200`] },
  { colour: "Cream & White", images: [`${CDN}indianbags2.jpg?v=1761682332&width=1200`] },
  { colour: "Turquoise", images: [`${CDN}indianbags3.jpg?v=1761682332&width=1200`] },
  { colour: "Cream & Taupe", images: [`${CDN}IndianBags1_b1392fe3-5266-4abb-bdc3-69b9910dc088.jpg?v=1761682331&width=1200`] },
];

const agondaVariants = [
  { colour: "Autumnal", images: [`${CDN}Aginda_Scarf_Autumnal_d5919d8e-c6b7-4132-a0c2-717e7c6c1cb7.jpg?v=1762103326&width=1200`] },
  { colour: "Autumnal 2", images: [`${CDN}AgondaScarfAutumnal2.jpg?v=1761929096&width=1200`] },
  { colour: "Pink", images: [`${CDN}AgondaScarfPink.jpg?v=1761928928&width=1200`] },
  { colour: "Pink 2", images: [`${CDN}AgondaScarfPink2.jpg?v=1761929096&width=1200`] },
  { colour: "Beige", images: [`${CDN}AgondaScarfBeige.jpg?v=1761929096&width=1200`] },
  { colour: "Blue", images: [`${CDN}AgondaScarfBlue.jpg?v=1761929096&width=1200`] },
  { colour: "Blue 2", images: [`${CDN}AgondaScarfBlue2.jpg?v=1761929096&width=1200`] },
  { colour: "Blue 3", images: [`${CDN}AgondaScarfBlue3.jpg?v=1761929096&width=1200`] },
  { colour: "Blue 4", images: [`${CDN}AgondaScarfBlue4.jpg?v=1761929096&width=1200`] },
  { colour: "Blue 5", images: [`${CDN}AgondaScarfBlue5.jpg?v=1761929096&width=1200`] },
  { colour: "Brown", images: [`${CDN}AgondaScarfBrown.jpg?v=1761929096&width=1200`] },
  { colour: "Dark Blue", images: [`${CDN}AgondaScarfDarkBlue.jpg?v=1761929096&width=1200`] },
  { colour: "Kimono Pink", images: [`${CDN}AgondaScarfLightPink.jpg?v=1761929096&width=1200`] },
  { colour: "Mint", images: [`${CDN}AgondaScarfMint.jpg?v=1761929096&width=1200`] },
  { colour: "Plum", images: [`${CDN}AgondaScarfPlum.jpg?v=1761928929&width=1200`] },
  { colour: "Yellow", images: [`${CDN}AgondaScarfYellow.jpg?v=1761928929&width=1200`] },
];

const mariposaVariants = [
  { colour: "Blue", images: [`${CDN}MariposaScarfBlue.jpg?v=1761929703&width=1200`] },
  { colour: "Blue 2", images: [`${CDN}MariposaScarfBlue2.jpg?v=1761930167&width=1200`] },
  { colour: "Blue 3", images: [`${CDN}MariposaScarfBlue3.jpg?v=1761930167&width=1200`] },
  { colour: "Blue 4", images: [`${CDN}MariposaScarfBlue4.jpg?v=1761929702&width=1200`] },
  { colour: "Peach", images: [`${CDN}MariposaScarfPeach.jpg?v=1761929702&width=1200`] },
  { colour: "Peach 2", images: [`${CDN}MariposaScarfPeach2.jpg?v=1761929702&width=1200`] },
  { colour: "Purple", images: [`${CDN}MariposaScarfPurple.jpg?v=1761929701&width=1200`] },
];

const junglePrintVariants = [
  {
    colour: "Blue Jungle",
    images: [
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/05de4u7f_image1.jpeg",
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/464iwadb_image0.jpeg",
    ],
  },
];

const palazzoVariants = [
  {
    colour: "Teal Blue & White Flower",
    images: [
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/60ickvjo_image3.jpeg",
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/40bg5a06_image0%20%281%29.jpeg",
    ],
  },
  {
    colour: "Pink & Blue Flower",
    images: [
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/tuejngv9_image0.jpeg",
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/mkfwviik_image1.jpeg",
    ],
  },
  {
    colour: "Orange & Yellow Flower",
    images: [
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/36vuwgr6_image1.jpeg",
      "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/urki5462_image0.jpeg",
    ],
  },
];

const yakVariants = [
  { colour: "Turquoise", images: [`https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/ac84abhu_image.png`, `${CDN}YakWoolMandalaScarfBlue3.jpg?v=1762462953&width=1200`] },
  { colour: "Beige", images: [`${CDN}YakWoolMandalaScarfBeige.jpg?v=1762462953&width=1200`] },
  { colour: "Black", images: [`${CDN}YakWoolMandalaScarfBlack.jpg?v=1761931001&width=1200`] },
  { colour: "Blue", images: [`${CDN}YakWoolMandalaScarfBlue.jpg?v=1762462953&width=1200`] },
  { colour: "Blue 2", images: [`${CDN}YakWoolMandalaScarfBlue2.jpg?v=1761931001&width=1200`] },
  { colour: "Green", images: [`${CDN}YakWoolMandalaScarfBlue4.jpg?v=1762462953&width=1200`] },
  { colour: "Brown", images: [`${CDN}YakWoolMandalaScarfBrown.jpg?v=1762462953&width=1200`] },
  { colour: "Purple", images: [`${CDN}YakWoolMandalaScarfPurple.jpg?v=1762462953&width=1200`] },
];

export const PRODUCTS = [
  {
    id: "palm-kaftan",
    name: "Palm Kaftan",
    price: 75,
    category: "women",
    sub: "Silk/Viscose blend · Hand-printed",
    badge: "Bestseller",
    description:
      "A vibrant kaftan featuring a unique hand-printed design and a flattering drawstring waist. Crafted from a soft silk/viscose blend, this midi-length kaftan adds individual style and breezy comfort to your wardrobe.",
    material: "Silk/Viscose",
    origin: "Hand-printed in Rajasthan, India",
    care: "Machine wash at 30°C. Warm iron on reverse. Do not tumble dry.",
    variants: palmKaftanVariants,
    images: flat(palmKaftanVariants),
    colours: palmKaftanVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "palm-dress",
    name: "Palm Dress",
    price: 75,
    category: "women",
    sub: "Cotton · Hand block print",
    badge: "New In",
    description:
      "A cotton knee-length dress with trim on the hem and sleeves. Hand printed in Rajasthan and available in a range of vibrant colourways.",
    material: "Silk/Viscose",
    origin: "Hand-printed in Rajasthan, India",
    care: "Machine wash at 30°C. Warm iron on reverse. Do not tumble dry.",
    variants: palmDressVariants,
    images: flat(palmDressVariants),
    colours: palmDressVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "kimono",
    name: "Kimono",
    price: 80,
    category: "women",
    sub: "Silk/Viscose · Flowing wrap",
    badge: "Limited",
    description:
      "A stunning wrap-design kimono in a range of vibrant colours. Crafted from a soft silk/viscose blend, it drapes beautifully with a silky texture — effortless style for any occasion.",
    material: "Silk/Viscose Blend",
    origin: "Handmade in India",
    care: "Machine wash cold. Warm iron.",
    variants: kimonoVariants,
    images: flat(kimonoVariants),
    colours: kimonoVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "palazzo-trousers",
    name: "Palazzo Trousers",
    price: 65,
    category: "women",
    sub: "Wide stretch waist · Two lengths",
    badge: "New In",
    description:
      "New Palazzo trousers with a wide, comfortable stretch waist that sits beautifully on any silhouette. Wide, flowing leg in a delicate hand-printed floral cotton. Available in two lengths — Short or Long — so you can find the perfect fit.",
    material: "Cotton",
    origin: "Hand-printed in India",
    care: "Machine wash cold. Warm iron on reverse. Do not tumble dry.",
    sizing: "Inside leg to hem — Short 53 cm · Long 66 cm",
    sizes: ["Short", "Long"],
    variants: palazzoVariants,
    images: flat(palazzoVariants),
    colours: palazzoVariants.map((v) => v.colour),
    pos: "center 40%",
  },
  {
    id: "hampi-linen-shirt",
    name: "Hampi Linen Shirt",
    price: 75,
    category: "men",
    sub: "100% Cotton · Contrast trim",
    badge: "New In",
    description:
      "Our Hampi men's linen shirt with cotton contrast inside the collar and cuffs, and contrasting buttons and stitching. Tailored for relaxed everyday wear.",
    material: "100% Cotton",
    origin: "Made in India",
    care: "Machine cool wash. Warm iron. Do not tumble dry.",
    sizing: "Arm length 53 cm · Chest 58 cm",
    variants: hampiVariants,
    images: flat(hampiVariants),
    colours: hampiVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "jungle-print-shirt",
    name: "Jungle Print Shirt",
    price: 75,
    category: "men",
    sub: "Cotton · Indian jungle print",
    badge: "New In",
    description:
      "A bold new shirt in deep indigo cotton, hand-printed with an Indian jungle motif of palms, foliage and birds. A large, loose, easy fit — made to be lived in, layered and loved.",
    material: "100% Cotton",
    origin: "Hand-printed in India",
    care: "Machine wash at 30°C. Warm iron on reverse. Do not tumble dry.",
    sizing: "Large loose fit",
    variants: junglePrintVariants,
    images: flat(junglePrintVariants),
    colours: junglePrintVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "goa-mens-shirt",
    name: "Goa Men's Shirt",
    price: 65,
    category: "men",
    sub: "100% Cotton · Block printed",
    badge: "Hand printed",
    description:
      "Our classic Goa smock shirt. Cotton block-printed in Rajasthan, with each piece stamped by artisans using wooden blocks. Buttons to the chest for an easy pull-on fit.",
    material: "100% Cotton",
    origin: "Block printed in Rajasthan, India",
    care: "Machine wash at 30°C. Warm iron on reverse. Do not tumble dry.",
    sizing: "Arm length 56 cm · Chest 62 cm",
    variants: goaVariants,
    images: flat(goaVariants),
    colours: goaVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "kerala-mens-shirt",
    name: "Kerala Men's Shirt",
    price: 65,
    category: "men",
    sub: "100% Cotton · Wood-block print",
    description:
      "Our classic Kerala men's shirt — pure cotton, block printed in Rajasthan by artisans who stamp each piece using wooden blocks. Available in a wide spectrum of prints.",
    material: "100% Cotton",
    origin: "Block printed in Rajasthan, India",
    care: "Machine wash at 30°C. Warm iron on reverse. Do not tumble dry.",
    sizing: "Arm length 56 cm · Chest 62 cm",
    variants: keralaVariants,
    images: flat(keralaVariants),
    colours: keralaVariants.map((v) => v.colour),
    pos: "center 30%",
  },
  {
    id: "indian-woven-bags",
    name: "Indian Woven Bags",
    price: 20,
    category: "accessories",
    sub: "Hand-woven · Made in India",
    badge: "Hand-woven",
    description:
      "Beautiful hand-woven bags with intricate patterns in a range of stylish colours. Perfect for the beach, a sunny excursion, or as a travel bag — artisan craft for any day out.",
    material: "Hand Woven Fabric",
    origin: "Made in India",
    variants: bagsVariants,
    images: flat(bagsVariants),
    colours: bagsVariants.map((v) => v.colour),
    pos: "center",
  },
  {
    id: "agonda-scarf",
    name: "Agonda Scarf",
    price: 65,
    category: "accessories",
    sub: "100% Wool · Classic pattern",
    description:
      "Our versatile Agonda Scarves feature a classic pattern in a beautiful range of colours. Crafted from soft 100% wool — a touch of style and warmth for any outfit.",
    material: "100% Wool",
    origin: "Made in India",
    care: "Hand wash in cold water. Do not tumble dry.",
    variants: agondaVariants,
    images: flat(agondaVariants),
    colours: agondaVariants.map((v) => v.colour),
    pos: "center",
  },
  {
    id: "mariposa-scarf",
    name: "Mariposa Scarf",
    price: 65,
    category: "accessories",
    sub: "Lightweight wool · Hand-stitched",
    badge: "One of a kind",
    description:
      "A unique scarf with hand-stitched, layered designs in vibrant one-off colour combinations. Lightweight wool — artisan style and warmth in equal measure.",
    material: "Lightweight Wool",
    origin: "Made in Kashmir",
    variants: mariposaVariants,
    images: flat(mariposaVariants),
    colours: mariposaVariants.map((v) => v.colour),
    pos: "center",
  },
  {
    id: "yak-wool-scarf",
    name: "Yak Wool Scarf",
    price: 70,
    category: "accessories",
    sub: "100% Yak wool · Herringbone weave",
    description:
      "A versatile scarf with a classic herringbone weave in a beautiful range of colours. Crafted from soft 100% yak wool — exceptional warmth and a refined finish.",
    material: "100% Yak Wool",
    origin: "Made in India",
    care: "Hand wash in cold water. Do not tumble dry.",
    variants: yakVariants,
    images: flat(yakVariants),
    colours: yakVariants.map((v) => v.colour),
    pos: "center",
  },
];

export const STORY_BLOCKS = [
  {
    title: "Artisanal Luxury",
    body:
      "Handmade in small batches using heritage techniques and ethically sourced premium materials — each piece authentic, each piece scarce.",
    image: "/values/v2.jpg",
    pos: "center 70%",
  },
  {
    title: "Sustainably Crafted",
    body:
      "Responsibly sourced renewable and recycled materials, and low-impact manufacturing — to cut CO₂, water use and waste.",
    image: "/values/v1.jpg",
    pos: "center 18%",
    contact: {
      role: "Founder",
      name: "Philippa",
      email: "hello@kaftanqueens.co.uk",
      phone: "+44 7711 253286",
    },
  },
  {
    title: "Bohemian Chic",
    body:
      "Relaxed vintage silhouettes, natural fabrics and global patterns for a layered look you can wear from sand to supper.",
    image: "/values/v3.jpg",
    pos: "center 18%",
  },
];

export const JOURNAL = [
  {
    id: "sustainable-luxury",
    title: "The Best Sustainable Luxury Fashion Brands",
    excerpt:
      "Love luxury fashion? Care about sustainability? Our edit of the year’s best eco-luxe labels — plus tips to make the most of your purchasing power.",
    image: "/journal/j1.jpg",
    pos: "center 35%",
  },
  {
    id: "eco-fabrics",
    title: "Top Eco-Fabrics That Are Good For You And Your Skin",
    excerpt:
      "Shopping for natural, eco-fabrics brings a range of fantastic benefits — not least the kindness they show to your skin.",
    image: "/journal/j2.jpg",
    pos: "center 40%",
  },
  {
    id: "fast-vs-slow",
    title: "Fast Vs. Slow Fashion: Can Fast Fashion Ever Be Slowed?",
    excerpt:
      "From ethical treatment of workers to sustainable materials and waste — the impact of fast fashion and whether it can ever truly slow down.",
    image: "/journal/j3.jpg",
    pos: "center 30%",
  },
];

export const ARTISAN = {
  title: "From the hands of artisans, directly to you",
  body:
    "Our handloomed, naturally dyed pieces support artisan communities across Northern India. We blend their slow-craft creations with modern silhouettes — so you can look beautiful, while doing good.",
  cta: { label: "Meet the Makers", to: "/about" },
  image:
    "https://customer-assets.emergentagent.com/job_image-scraper-3/artifacts/3ifkir8k_488535633_17854982841410310_5228255946688593398_n.jpg",
};

export const TESTIMONIALS = [
  { name: "Olivia, London", quote: "The Palm Kaftan is the most complimented thing I own. The quality is unreal and you can feel the craftsmanship." },
  { name: "Priya, Edinburgh", quote: "My wool scarf arrived wrapped like a gift. Knowing it was hand-loomed makes it feel like an heirloom already." },
  { name: "Marcus, Brighton", quote: "My Hampi shirt is on heavy rotation. Cut, colour, weight — everything is spot on." },
];
